import { render, staticRenderFns } from "./requestLeave.vue?vue&type=template&id=e2c88f14&scoped=true"
import script from "./requestLeave.vue?vue&type=script&lang=js"
export * from "./requestLeave.vue?vue&type=script&lang=js"
import style0 from "./requestLeave.vue?vue&type=style&index=0&id=e2c88f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c88f14",
  null
  
)

export default component.exports